import { PossibleApiStatusValues } from "../store/helperfuncs";

const GeneralApiLoading = ({
  possibleApiValue,
  children,
  loadingComponent,
}) => {
  // possible api values can be notstarted, loading, failed
  if (possibleApiValue === PossibleApiStatusValues.loading)
    return loadingComponent ? loadingComponent : <div>loading...</div>;

  if (possibleApiValue === PossibleApiStatusValues.failed)
    return <div>Something failed at server!</div>;

  if (possibleApiValue === PossibleApiStatusValues.notstarted)
    return <div>not started</div>;

  return children;
};

export default GeneralApiLoading;
